import React from 'react'
import { PrimaryHeading } from 'ui/headings'
import { PageTitle } from '@morningtrain/react-app'
import WithSubtitle from '../layouts/WithSubtitle'

export default function PageHeader ({ title = null, subtitle = null, children }) {
  return (
    <>
      <div className='flex xl:items-center justify-between mb-8 flex-col xl:flex-row space-y-4'>
        <div className='flex items-center'>
          {subtitle
            ? (
              <WithSubtitle subtitle={subtitle}>
                <PrimaryHeading>
                  {title || <PageTitle />}
                </PrimaryHeading>
              </WithSubtitle>
              )
            : (
              <PrimaryHeading>
                {title || <PageTitle />}
              </PrimaryHeading>
              )}

        </div>
        {children}
      </div>
    </>
  )
}
